import { render, staticRenderFns } from "./emergencyTeam.vue?vue&type=template&id=63f5d378&scoped=true&"
import script from "./emergencyTeam.vue?vue&type=script&lang=js&"
export * from "./emergencyTeam.vue?vue&type=script&lang=js&"
import style0 from "./emergencyTeam.vue?vue&type=style&index=0&id=63f5d378&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5d378",
  null
  
)

export default component.exports